import type {ReactNode} from 'react'

export function BookingRulesContent({rows, children}: {rows: Array<{id: string; label?: string; value: ReactNode}>; children?: ReactNode}) {
    return <div className="space-y-3">
        {rows.length ? <ul className="list-disc space-y-1 pl-5 text-sm leading-6 text-gray-600 dark:text-gray-300">
            {rows.map(row => <li key={row.id}>{row.label ? <><span className="font-medium">{row.label}:</span> </> : null}{row.value}</li>)}
        </ul> : null}
        {children}
    </div>
}
